import dayjs from 'dayjs';
import i18n from 'i18next';
import { useState, useEffect } from 'react';
import 'dayjs/locale/fr';
import 'dayjs/locale/en';

interface MonthsData {
  fullName: string;
  shortName: string;
  index: number;
}

const useMonths = () => {
  const [months, setMonths] = useState<MonthsData[]>([]);
  const locale = i18n.language;

  useEffect(() => {
    dayjs.locale(locale);

    const updatedMonths: MonthsData[] = [];

    for (let i = 0; i < 12; i++) {
      const date = dayjs().month(i).startOf('month');

      updatedMonths.push({
        fullName: date.format('MMMM'),
        shortName: date.format('MMM'),
        index: parseInt(date.format('MM')),
      });
    }

    setMonths(updatedMonths);
  }, [locale]);

  return months;
};

export default useMonths;
